import { render, staticRenderFns } from "./edit-ticket.vue?vue&type=template&id=1a821cf3&scoped=true&"
import script from "./edit-ticket.vue?vue&type=script&lang=ts&"
export * from "./edit-ticket.vue?vue&type=script&lang=ts&"
import style0 from "./edit-ticket.vue?vue&type=style&index=0&id=1a821cf3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a821cf3",
  null
  
)

component.options.__file = "edit-ticket.vue"
export default component.exports